import { AxiosResponse } from "axios"

import { axiosStudent, axiosUsersApi, getIdEntity } from "../../../config/axios"
import catchException from "../../../shared/status/StatusFunction"
import { controllerGetCurrent } from "./HomeController"
import { IFavoriteCourse, IResponseFavoriteService, IResponseLessonTodayService } from '../interfaces/IStateHome'

export const getCurrentService = async (dispatch: any) => {

    return await axiosStudent({
        url: 'api',
        method: "post",
        data: {
            fname: "getScheduledsCoursesActivesByUser",
            entity_id: getIdEntity(localStorage)
        }
    }).then(async ({ data }) => {
        // console.log('DATAAA')
        // console.log(data);
        const result: any = await Promise.all(
            data.courses.map(async (c: any) => {
                const { data }: any = await axiosStudent({
                    url: "/api",
                    method: "post",
                    data: {
                        fname: "getCourseModules_byUser",
                        scheduled_id: c._id,
                        course_id: c.course._id,
                    }
                });
                return {
                    id: c._id,
                    modules: data.modules,
                    name: c.name
                }
            })
        );

        const resp = controllerGetCurrent(result);

        dispatch({
            type: 'GET_CURRENT',
            payload: resp
        });

    }).catch((e) => {
        catchException({ e, dispatch, stateType: 'STATUS_SCREEN', method: 'not' });
    })

}

export interface IResponseLessonService {
    message: string;
    Lessons: any[];
}

export const getHomeService = async (dispatch: any) => {

    return await axiosStudent({
        url: 'api',
        method: "post",
        data: {
            fname: "getLessonsForToday",
            entity: getIdEntity(localStorage)
        }
    }).then(({ data }: AxiosResponse<IResponseLessonTodayService>) => {
        // console.log('GET LESSONS FOR TODAY')
        // console.log(data.Lessons)
        dispatch({
            type: 'SET_CURRENTS_LESSONS_TODAY',
            payload: data.Lessons
        })
        dispatch({
            type: 'STATUS_SCREEN',
            payload: { type: '200', text: '', status: 'not' }
        });

    }).catch((e) => {
        
        catchException({ e, dispatch, stateType: 'STATUS_SCREEN', method: 'not' })
    })

};


export const getFavouritesService = async (dispatch: any) => {

    return await axiosStudent({
        url: 'api',
        method: "post",
        data: {
            fname: "getFavorites",
            entity: getIdEntity(localStorage)
        }
    }).then(({ data }: AxiosResponse<IResponseFavoriteService>) => {
        let newFavourites: IFavoriteCourse [] = data.favoriteCourses.map(f => ({
            id: f._id,
            nombre: f.scheduled.name,
            // categoria: f.scheduled.category.name,
            categoria: f.scheduled.course.name,
            sede: f.scheduled.campus?.name || 'sede',
            scheduled_id: f.scheduled._id
        }))

        dispatch({
            type: 'SET_FAVOURITES',
            payload: newFavourites
        })

        dispatch({
            type: 'STATUS_SCREEN',
            payload: { type: '200', text: '', status: 'not' }
        });

    }).catch((e) => {
        
        catchException({ e, dispatch, stateType: 'STATUS_SCREEN', method: 'not' })
    })
}

export const addToFavouritesService = async (scheduled_id: string, dispatch: any) => {

    return await axiosStudent({
        url: 'api',
        method: "post",
        data: {
            fname: "addToFavorites",
            entity: getIdEntity(localStorage),
            scheduled_id
        }
    }).then(async ({ status }: AxiosResponse) => {

        if (status === 200) await getFavouritesService(dispatch)

    }).catch((e) => {
        
        catchException({ e, dispatch, stateType: 'STATUS_SCREEN', method: 'not' })
    })
}

export const removeFromFavoritesService = async (favorite_id: string, dispatch: any) => {

    return await axiosStudent({
        url: 'api',
        method: "post",
        data: {
            fname: "removeFromFavorites",
            favorite_id
        }
    }).then(async ({ status }: AxiosResponse) => {

        if (status === 200) await getFavouritesService(dispatch)

    }).catch((e) => {
        
        catchException({ e, dispatch, stateType: 'STATUS_SCREEN', method: 'not' })
    })
}

export const checkUserEmailVerify = async () => {

    let emailStatus: string = 'verified'; 

    await axiosUsersApi({
        url: 'v5.0.1/api',
        method: "post",
        data: { fname: "email_is_verified" }
    }).then(async ({ data }: AxiosResponse) => {
        return emailStatus = data.email_verification ? 'verified' : 'no-verified';
    }).catch((e) => {
        console.log('YYYYYYYYYYYYYYYYYYYYYYYYYYYYYY',e, e.response);
    })

    return emailStatus;

}

